import { render, staticRenderFns } from "./clientDisplayValencia.vue?vue&type=template&id=ecf9050a&scoped=true&"
import script from "./clientDisplayValencia.vue?vue&type=script&lang=js&"
export * from "./clientDisplayValencia.vue?vue&type=script&lang=js&"
import style0 from "./clientDisplayValencia.vue?vue&type=style&index=0&id=ecf9050a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf9050a",
  null
  
)

export default component.exports